import { UserListIcon, UsersThreeIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import type { ListVisibility } from 'app/types/list-visibility'
import { PERSONAL_LIST_NOTE, SHARED_LIST_NOTE } from 'lib/listVisibility'

const TAGS = {
  personal: { Icon: UserListIcon, label: `Personal`, note: PERSONAL_LIST_NOTE },
  shared: { Icon: UsersThreeIcon, label: `Shared`, note: SHARED_LIST_NOTE },
} as const

/** Who sees a list, in words, where there is room for more than the sidebar's lock. */
export function ListVisibilityTag({ visibility }: { visibility: ListVisibility }): ReactElement {
  const { Icon, label, note } = TAGS[visibility]
  return (
    <Tooltip message={note} className="flex shrink-0">
      <span className="flex items-center gap-1 text-label-xs text-subtle">
        <Icon size={12} weight="bold" aria-hidden="true" />
        {label}
      </span>
    </Tooltip>
  )
}
